/*tslint:disable:no-console*/
import React from 'react';
import '../../scss/_cost.scss';
import { IAddRowAction } from './AddRowActions';
import CostData from './CostData';
import CostTitle from './CostTitle';
import styled from 'styled-components';
import { ITotals } from '../../ui-toolkit/cdItems/interfaces/ITotals';
import { IHasTestData } from '../../ui-toolkit/test-utilities/IHasTestData';
import { mergeTests } from '../../ui-toolkit/test-utilities/mergeTests';

export interface ISection extends IHasTestData {
  addRowActions?: IAddRowAction[];
  /** Automation Focused Prop. Is adjusted by children to make their usage of the ID unique(ish). */
  totals?: ITotals | null;
  name?: string;
  showLenderPaid: boolean;
  showNettedOut: boolean;
  showSeller: boolean;
  className?: string;
  hasEditPermissions?: boolean;
  children?: React.ReactNode;
}

const StyledSection = styled.div`
  counter-reset: cost-data;
`;

export default class Section extends React.Component<ISection> {
  public static defaultProps = {
    showLenderPaid: true,
    showNettedOut: true,
  };

  public render() {
    const {
      addRowActions,
      children,
      'data-test-id': dataTestID,
      name,
      showLenderPaid,
      showNettedOut,
      showSeller,
      totals,
      hasEditPermissions,
    } = this.props;
    const buyerValue = totals ? totals.buyer_paid || 0 : 0;
    const sellerValue = totals ? totals.seller_paid || 0 : 0;
    const otherValue = totals ? totals.paid_by_others || 0 : 0;
    return (
      <StyledSection data-test-id={mergeTests(dataTestID, 'wrapper')}>
        {name ? (
          <CostTitle
            name={name}
            showSeller={showSeller}
            showLenderPaid={showLenderPaid}
            buyerValue={buyerValue}
            sellerValue={sellerValue}
            otherValue={otherValue}
            hasEditPermissions={hasEditPermissions}
          />
        ) : null}
        <CostData
          mode={showSeller ? 'seller' : 'default'}
          showLenderPaid={showLenderPaid}
          showNettedOut={showNettedOut}
          addRowActions={addRowActions}
          data-test-id={mergeTests(dataTestID, 'cost-data')}
          addRowActionsDisabled={!hasEditPermissions}
        >
          {children}
        </CostData>
      </StyledSection>
    );
  }
}
